module.exports = __webpack_public_path__ + "8b7199d559e6e7cb158b5cf70b7f8b5c.svg";